import { Component, OnInit, Input, Inject, OnDestroy } from '@angular/core';
import { RechargeBoxService } from '../../../_service/recharge-box/recharge-box.service';
import { environment } from '../../../../environments/environment';
import { Utility } from '../../../_service/utility';

import { Unsubscribable } from 'rxjs';

// import { User } from 'app/_model/user/user.model';
import { StorageService } from 'app/storageprovider';
import { UserService } from '../../../_service/user/user.service';
import { User } from 'app/_model/user/user.model';
import { RechargeService } from '../../../_service/recharge/recharge.service';

@Component({
  selector: 'app-dropdown-recharge',
  templateUrl: './dropdown-recharge.component.html',
  styleUrls: ['./dropdown-recharge.component.scss']
})

export class DropdownRechargeComponent implements OnInit,OnDestroy {
  isAdult = environment.cinema === 2;

  @Input() data: any;
  user:User = new User(true);
  isDark = false;
  constructor(
    private _rechargeBoxService: RechargeBoxService,
    private _rechargeService:RechargeService,
    private _storage: StorageService,
    private _userService:UserService,
    private _utility:Utility,
  ) {

  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(p=>p.unsubscribe());
    // if(this.unsb!=null)this.unsb();
  }
  subscriptions:Array<Unsubscribable> = [];
  ngOnInit() {
    //this.user = this._userService.user;
    this.subscriptions.push(
      this._rechargeService.productState$.subscribe(p=>{
        if(!p.hasValue)
        {
          return;
        }
        this.discountList = p.state.discountInfo;

      }),
    

    this._userService.userState$.subscribe(user=>{
      this.user = user;
     // console.log(this.user)
    }),
    // this.unsb = this.store.subscribe(() => this.readState());
    // this.readState();
    this._utility.GetOrCreateSubscript("theme.change").subscribe((theme) => {
      // console.log(theme);
      if (theme == "dark") {
        this.isDark = true;
      }
      else {
        this.isDark = false;
      }

    }));
    this.isDark = !!parseInt(this._storage.GetConfig()["isDark"]|| "1") ;
  }
  unsb = null
  readState() {
    // const state: UsersState = this.store.getState()['users'] as UsersState;
    // this.user = new User(true);
    // Object.assign(this.user, state.currentUser);
    // this.user = state.currentUser || {
    //   daysOfMembership:0
    // };
   // console.log(this.user)
  }
 
  discountList = [];
  showRechargeBox() {
    this._rechargeBoxService.changeDisplayStatus(true);
    // this._router.navigate(['/vip-center/recharge'], { queryParams: {forOther: '0'} });
  }

}
